module.exports = __webpack_public_path__ + "static/media/im.bed05fde.svg";